import React, { CSSProperties, PropsWithChildren } from 'react';

import { styled } from '../theme';
import Text from './Text';

type TextType = 'normal' | 'bolder' | 'lighter';

type Props = PropsWithChildren & {
    type?: TextType;
    className?: string;
    style?: CSSProperties;
};

const getFontColor = (type: TextType, theme): string => {
    switch (type) {
        case 'lighter':
            return theme.color.gray70;
        default:
            return theme.color.jetBlack;
    }
};

const getFontWeight = (type: TextType, theme): string => {
    switch (type) {
        case 'bolder':
            return theme.typography.fontWeight.medium;
        default:
            return theme.typography.fontWeight.roman;
    }
};

const getFontSize = (type: TextType, theme): string => {
    switch (type) {
        case 'lighter':
            return '1.4rem';
        default:
            return '1.5rem';
    }
};

const StyledText = styled(Text)<Props>(({ theme, type }) => ({
    fontFamily: theme.typography.fontFamily,
    fontWeight: getFontWeight(type, theme),
    fontSize: getFontSize(type, theme),
    color: getFontColor(type, theme),
}));

const TableText = React.forwardRef<HTMLSpanElement, Props>(({ type = 'normal', ...props }, ref) => (
    <StyledText type={type} ref={ref} {...props} />
));

export default TableText;
